"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TbTableRows = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var TbTableColumn_1 = require("./TbTableColumn");
var useStyles = (0, core_1.makeStyles)(function () {
    return (0, core_1.createStyles)({
        tableRow: {
            cursor: 'pointer'
        }
    });
});
var TbTableRows = function (_a) {
    var columns = _a.columns, rows = _a.rows, color = _a.color, valueMapper = _a.valueMapper, onClickRow = _a.onClickRow;
    var classes = useStyles({ color: color });
    return (rows != null)
        ? react_1.default.createElement(react_1.default.Fragment, null, rows.map(function (row, rowIndex) {
            return (react_1.default.createElement(core_1.TableRow, { "data-testid": 'tableRow', onClick: function () { return onClickRow === null || onClickRow === void 0 ? void 0 : onClickRow(row); }, classes: { root: classes.tableRow }, hover: true, tabIndex: -1, key: "row-" + rowIndex, "aria-label": "row-" + rowIndex }, columns.map(function (column, columnIndex) { return react_1.default.createElement(TbTableColumn_1.TbTableColumn, { key: "row-" + rowIndex + "_column-" + columnIndex, color: color, row: row, rowIndex: rowIndex, column: column, columnIndex: columnIndex, valueMapper: valueMapper }); })));
        }))
        : null;
};
exports.TbTableRows = TbTableRows;
//# sourceMappingURL=TbTableRows.js.map